<div class="qvs-registration-error">
  <div class="qvs-registration-error__content" [class.qvs-registration-error__content--disable-background]="disableBackground">
    <qvs-svg-icon class="qvs-registration-error__icon" [src]="'assets/images/error.svg'"></qvs-svg-icon>
    <h2 class="qvs-registration-error__title" *ngIf="title">
      {{ title }}
    </h2>

    <p class="qvs-registration-error__paragraph" *ngIf="paragraphOne">
      {{ paragraphOne }}
    </p>

    <p class="qvs-registration-error__paragraph" *ngIf="paragraphTwo">
      {{ paragraphTwo }}
    </p>

    <a *ngIf="supportMail" class="qvs-registration-error__mail" [attr.href]="'mailto:' + supportMail">
      {{ supportMail }}
    </a>

    <a *ngIf="supportPhone" class="qvs-registration-error__phone" [attr.href]="'tel:' + supportPhone">
      {{ supportPhone }}
    </a>

    <ion-button
      *ngIf="buttonText"
      class="qvs-registration-error__button"
      type="button"
      [disabled]="isButtonDisabled"
      (click)="buttonClick.emit()"
    >
      <span class="qvs-registration-error__button-inner">
        <qvs-svg-icon class="qvs-registration-error__button-icon" [src]="'assets/icons/refresh.svg'"></qvs-svg-icon>
        <span>{{ buttonText }}</span>
      </span>
    </ion-button>
  </div>
</div>
